import { createSlice } from '@reduxjs/toolkit';

import { INITIAL_LIST_PARAMS } from 'config';
import { OrderState, PriceTypes } from '../../types/order';
import { DateTypes } from 'types/client';

const initialState: OrderState = {
  isLoading: false,
  orderList: {},
  orderListParams: INITIAL_LIST_PARAMS,
  filtersListParams: INITIAL_LIST_PARAMS,
  filtersErrors: {
    [DateTypes.PAID_AT_START]: '',
    [DateTypes.PAID_AT_END]: '',
    [DateTypes.EXPIRED_AT_START]: '',
    [DateTypes.EXPIRED_AT_END]: '',
    [PriceTypes.PRICE_FROM]: '',
    [PriceTypes.PRICE_TO]: '',
  },
  orderClientList: {},
  orderClientListParams: INITIAL_LIST_PARAMS,
};

const slice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getOrderListSuccess(state, action) {
      state.isLoading = false;
      state.orderList = action.payload;
    },

    getOrderSuccess(state, action) {
      state.isLoading = false;
      state.order = action.payload;
    },

    setOrderListParams(state, action) {
      state.orderListParams = action.payload;
    },

    getOrderClientListSuccess(state, action) {
      state.isLoading = false;
      state.orderClientList = action.payload;
    },

    setOrderClientListParams(state, action) {
      state.orderClientListParams = action.payload;
    },

    setFiltersListParams(state, action) {
      state.filtersListParams = action.payload;
    },

    setFiltersErrors(state, action) {
      state.filtersErrors = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  getOrderListSuccess,
  getOrderSuccess,
  setOrderListParams,
  getOrderClientListSuccess,
  setOrderClientListParams,
  setFiltersListParams,
  setFiltersErrors,
} = slice.actions;
